/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  const reportesDisponibles = currentUser?.reportes || []

  return (
    <>
      <SidebarMenuItem to='/dashboard' icon='home' title='Home' fontIcon='bi-app-indicator' />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Socios</span>
        </div>
      </div>

      <SidebarMenuItem to='/socios/listado' title='Socios' icon='bi bi-person-lines-fill' />
      <SidebarMenuItem
        to='/socios/ingresar'
        title='Nuevo Socio'
        icon='bi bi-person-plus-fill fs-2 '
      />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Cuentas</span>
        </div>
      </div>

      <SidebarMenuItem
        to='/cuentas/listado'
        title='Listado de cuentas'
        fontIcon='bi-person'
        icon='bi bi-wallet2'
      />
      <SidebarMenuItem to='/movimientos/listado' title='Movimientos' icon='bi bi-clock-history' />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Servicios</span>
        </div>
      </div>

      <SidebarMenuItem to='/servicios/listado' title='Listado de servicios' icon='bi bi-receipt' />

      <SidebarMenuItem to='/servicios/ingresar' title='Nuevo Servicio' icon='bi bi-plus-square ' />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Usuarios</span>
        </div>
      </div>

      <SidebarMenuItem to='/usuarios' title='Listado de usuarios' icon='bi bi-people' />
      <SidebarMenuItem to='/usuarios/crear' title='Nuevo Usuario' icon='bi bi-person-plus' />

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Cobranza</span>
        </div>
      </div>

      <SidebarMenuItem to='/cobranza/emitir' title='Emitir Cobranza' icon='bi bi-bank' />

      <SidebarMenuItem to='/pagos/ingresar' title='Ingresar Pago' icon='bi bi-cash ' />

      <SidebarMenuItem
        to='/cobranza/comisiones'
        title='Ingresar Comisiones'
        icon='bi bi-cash-coin'
      />

      {/* Sección de Reportes - Dinámica según usuario */}
      {reportesDisponibles.length > 0 && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Reportes</span>
            </div>
          </div>

          {reportesDisponibles.map((reporte) => (
            <SidebarMenuItem
              key={reporte.slug}
              to={`/reportes/${reporte.slug}`}
              title={reporte.nombre}
              icon='bi bi-bar-chart-line'
            />
          ))}
        </>
      )}
    </>
  )
}

export {SidebarMenuMain}
